/*******
* js functionality for accordion pages
*
********/

$(document).ready( function() {
	Accordion();
});

function Accordion(){
    
    // check for section hash in url
    var hash = window.location.hash;
    if( $(hash).length ){
        
        // if element with that id exists, toggle it open
        var toggle = $(hash).find('.toggle');
        var id = toggle.data('contentid');
        $('#'+id).slideToggle(150).toggleClass('open');
        $('.'+id).toggleClass('open');
    }
    
    // on click of toggle trigger
    $('.toggle').click(function(){
        // get its content and toggle it open
        var id = $(this).data('contentid');
        $('#'+id).slideToggle(150).toggleClass('open');
        $('.'+id).toggleClass('open');
    });
    
}